////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Pull-quote — the `> ...` blocks seen throughout the news scrape  //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import type { ReactNode } from 'react';

export interface PullQuoteProps {
  children: ReactNode;
  cite?: string;
}

export function PullQuote ({ children, cite }: PullQuoteProps) {
  return (
    <blockquote className="border-l-4 border-line pl-6 text-xl italic text-ink/90">
      {children}
      {cite && <footer className="mt-2 text-sm not-italic text-muted">{cite}</footer>}
    </blockquote>
  );
}
